import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { Button } from 'components/Button';
import { Title, Text } from 'components/Text';
import { CardWrapper, BoxButton } from './styles';

// Modal de Ajuda
const HelpModal = ({ onClose }) => {
  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        onClose();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);

  return (
    <CardWrapper ref={wrapperRef}>
      <IconButton
        color="secondary"
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
      <Title secondary>
        Sobre o Download
      </Title>
      <Text>
        Os documentos disponibilizados para download são muito importantes para que você entre com o processo. A petição inicial contém seu nome, documentos, endereço e ainda demonstra seu direito, com fundamentos jurídicos simples e diretos. O cálculo permite que você apresente para o Juiz o quanto seu FGTS perdeu valor de compra com o passar dos anos. Esse conjunto permitirá que você acesse a Justiça, exercendo sua cidadania.
      </Text>
      <BoxButton>
        <Button onClick={() => {
          window.Intercom('trackEvent', `LOIT FGTS chat de ajuda - ${window.location.pathname.replace('/', '')}`);
          window.Intercom('show');
          onClose(false);
        }}
        >
          Iniciar conversa com o suporte
        </Button>
      </BoxButton>
    </CardWrapper>
  );
};

HelpModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default HelpModal;
